/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */

import { Fragment } from '@wordpress/element';
import { InspectorControls, PanelColorSettings } from '@wordpress/block-editor';
import { RangeControl, PanelBody, SelectControl } from '@wordpress/components';
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { attributes, setAttributes } = props;
	const { layout, btnBorderRadius, questionBackgroundColor, questionTextColor, answerBackgroundColor, answerTextColor, btnBorderColor, btnTextColor, btnBackgroundColor } = attributes;

	const questionBackgroundColorSettings = [
		{
			value: questionBackgroundColor,
			onChange: colorValue => setAttributes({ questionBackgroundColor: colorValue }),
			label: __( 'Question Background Color', 'wp-travel-blocks' )
		}
	];

	const questionTextColorSettings = [
		{
			value: questionTextColor,
			onChange: colorValue => setAttributes({ questionTextColor: colorValue }),
			label: __( 'Question Text Color', 'wp-travel-blocks' )
		}
	];

	const answerBackgroundColorSettings = [
		{
			value: answerBackgroundColor,
			onChange: colorValue => setAttributes({ answerBackgroundColor: colorValue }),
			label: __( 'Answer Background Color', 'wp-travel-blocks' )
		}
	];

	const answerTextColorSettings = [
		{
			value: answerTextColor,
			onChange: colorValue => setAttributes({ answerTextColor: colorValue }),
			label: __( 'Answer Background Color', 'wp-travel-blocks' )
		}
	];

	const btnBorderColorSettings = [
		{
			value: btnBorderColor,
			onChange: colorValue => setAttributes({ btnBorderColor: colorValue }),
			label: __( 'Button Border Color', 'wp-travel-blocks' )
		}
	];

	const btnTextColorSettings = [
		{
			value: btnTextColor,
			onChange: colorValue => setAttributes({ btnTextColor: colorValue }),
			label: __( 'Button Text Color', 'wp-travel-blocks' )
		}
	];

	const btnBackgroundColorSettings = [
		{
			value: btnBackgroundColor,
			onChange: colorValue => setAttributes({ btnBackgroundColor: colorValue }),
			label: __( 'Button Text Color', 'wp-travel-blocks' )
		}
	];

	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<InspectorControls>
					<PanelBody title={ __( 'FAQ options', 'wp-travel-blocks' ) } >
						<SelectControl
							label={ __( 'Select Layout', 'wp-travel-blocks' ) }
							value={ layout }
							options={ [
								{ label: 'Default Design', value: 'first-design' },
								{ label: 'Second Design', value: 'second-design' },
							] }
							onChange={ ( value ) => setAttributes( { layout: value } ) }
						/>
						<RangeControl
							label={__('Button Border Radius')}
							onChange={ (value) => setAttributes( { btnBorderRadius: value } ) }
							shiftStep={ 1 }
							min={ 2 }
							max={ 100 }
							value={ btnBorderRadius }
						/>
						<PanelColorSettings
							title={__('Question Background Color', 'wp-travel-blocks')}
							colorSettings={questionBackgroundColorSettings}
							initialOpen={false}
						/>
						<PanelColorSettings
							title={__('Question Text Colors', 'wp-travel-blocks')}
							colorSettings={questionTextColorSettings}
							initialOpen={false}
						/>
						<PanelColorSettings
							title={__('Answer Background Color', 'wp-travel-blocks')}
							colorSettings={answerBackgroundColorSettings}
							initialOpen={false}
						/>
						<PanelColorSettings
							title={__('Answer Text Colors', 'wp-travel-blocks')}
							colorSettings={answerTextColorSettings}
							initialOpen={false}
						/>
						<PanelColorSettings
							title={__('Button Border Colors', 'wp-travel-blocks')}
							colorSettings={btnBorderColorSettings}
							initialOpen={false}
						/>
						<PanelColorSettings
							title={__('Button Text Colors', 'wp-travel-blocks')}
							colorSettings={btnTextColorSettings}
							initialOpen={false}
						/>
						<PanelColorSettings
							title={__('Button Background Colors', 'wp-travel-blocks')}
							colorSettings={btnBackgroundColorSettings}
							initialOpen={false}
						/>
					</PanelBody>
				</InspectorControls>
			</Fragment>
			<ServerSideRender
				block="wp-travel-blocks/trip-faqs"
				attributes={ props.attributes }
			/>
		</div>
	);
}
